import SiteHeader from "./SiteHeader";
import ProductCarousel from "./ProductCategoriesCarousel";
import Timeline from "./Timeline";
import Slideshow from "./Slideshow";
import DynamicSubmenu from "./DynamicSubmenu";
import JobOffers from "./JobOffers";

(() => {
    new SiteHeader()
    new ProductCarousel()
    new Timeline()
    new Slideshow()
    new DynamicSubmenu()
    new JobOffers()
})()


